import { Rpc } from '../rpc';
import { RpcObservableServer } from '../rpc-observable-server';
import {
    RpcObservableCopilotConfigRequest, RpcObservableCopilotError, RpcObservableCopilotKey, RpcObservableCopilotResult
} from './rpc-observable-copilot-model';

/**
 * Shell to Iframe pair, the receiving/Iframe port.
 */
export class RpcObservableCopilotConfigServer
    extends RpcObservableServer<RpcObservableCopilotConfigRequest, RpcObservableCopilotResult, RpcObservableCopilotError> {

    /**
     * Initializes a new instance of the RpcObservableCopilotConfigServer class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservableCopilotKey.configCommand, RpcObservableCopilotKey.version);
    }
}
